import { FC, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import "./CollectionDetail.scss";
import Header from "../../components/Header";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../utils/constants";
import Footer from "../../components/Footer";
import "../../assets/scss/common.scss";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import ReactGA from "react-ga4";

export const CollectionDetailPage: FC = () => {
	const navigate = useNavigate();
	const nftDetails = useSelector(
		({ nftData }) => nftData.nftDetails,
		shallowEqual
	);
	const gaEventTracker = useAnalyticsEventTracker("NFT Details Page");

	useEffect(() => {
		if (!nftDetails?.name) {
			navigate(PageRoutes.Home);
		}
		gaEventTracker(nftDetails.page);
	}, []);

	return (
		<>
			<Header />
			<main className="main-content">
				<div className="inner-content">
					<section className="epic-main-wrapper">
						<Container>
							<Row className="epic-mobile-view">
								<Col lg={7}>
									<div className="epic-left-part-main">
										<div
											className="back-btn"
											onClick={() => {
												navigate(-1);
											}}
										>
											<span>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
														stroke="white"
														stroke-width="1.5"
														stroke-miterlimit="10"
														stroke-linecap="round"
														stroke-linejoin="round"
													/>
												</svg>
											</span>
											Back
										</div>
										<h1 className="epic-title">
											{nftDetails?.name}
											{/* Epic Gorilla<span>#77</span> */}
										</h1>
										<p className="epic-content">{nftDetails?.description}</p>
									</div>
									<div className="epic-coin-price-section">
										<div className="epic-coin-amount">
											{/* 0.084 <span>($22,542.03)</span> */}
										</div>
										{/* <div className="epic-coin-price">
                  <div className="epic-user-img">
                    <img src="/EpicUser.png" alt="EpicUser" />
                  </div>
                  Ape_26
                </div> */}
									</div>
									<Row>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title ">
													<div className="address">
														{nftDetails.tokenAddress}
													</div>
													<div>{nftDetails?.tokenAddress?.substr(-4)}</div>
												</div>
												<div className="epic-box-content">Token Address</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">{nftDetails.chain}</div>
												<div className="epic-box-content">Chain</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">
													{nftDetails.network}
												</div>
												<div className="epic-box-content">Network</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">-</div>
												<div className="epic-box-content">All Time High</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">-</div>
												<div className="epic-box-content">Price Change</div>
											</div>
										</Col>
									</Row>
								</Col>
								<Col lg={{ span: 4, offset: 1 }}>
									<div className="mobile-back-btn">
										<span>
											<svg
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
													stroke="white"
													stroke-width="1.5"
													stroke-miterlimit="10"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</span>
										Back
									</div>
									<div className="epic-right-side-image">
										<img src={nftDetails?.imageUrl} alt="Bear" />
									</div>
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<div className="price-history-main">
										<div className="price-history">Price History</div>
										<div className="price-history-filter">
											<span>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M19.9201 8.99991L13.4001 15.5199C12.6301 16.2899 11.3701 16.2899 10.6001 15.5199L4.08008 8.99991"
														stroke="white"
														stroke-width="1.5"
														stroke-miterlimit="10"
														stroke-linecap="round"
														stroke-linejoin="round"
													/>
												</svg>
											</span>
											<Form.Select
												className="price-filter-select"
												aria-label="Default select example"
											>
												<option>Today</option>
												<option value="1">Weekly</option>
												<option value="2">Monthly</option>
												<option value="3">Yearly</option>
											</Form.Select>
										</div>
									</div>
									<div className="epic-price-chart">
										<div className="epic-price-chart-img">
											<img src="/Chart.png" alt="Bear" />
										</div>
									</div>
								</Col>
							</Row>
						</Container>
					</section>
				</div>
				<Footer></Footer>
			</main>
		</>
	);
};
